module.exports = require("handlebars/runtime")["default"];
